import { Form, Input, Row } from "antd";
import { useState, useEffect, useMemo, useCallback, ReactNode } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { useGetEmailFormRules } from "../../../../../../lib/hooks/getEmailFormRules";

type ToggleAlternateEmailProps = {
  hasAlternateEmail: boolean;
};

export const ToggleAlternateEmail = ({
  hasAlternateEmail,
}: ToggleAlternateEmailProps) => {
  const [isAddAlternateEmail, setIsAddAternateEmail] = useState<boolean>(false);

  const { rules } = useGetEmailFormRules();

  const formattedRules = useMemo(() => rules.slice(0, -1), [rules]);

  useEffect(() => {
    setIsAddAternateEmail(hasAlternateEmail);
  }, [hasAlternateEmail]);

  const toggleEmail = useCallback((): void => {
    setIsAddAternateEmail(!isAddAlternateEmail);
  }, [isAddAlternateEmail]);

  const label = useMemo((): ReactNode => {
    return (
      <Row className="align-center logo-cursor" onClick={toggleEmail}>
        Alternate Email <CloseOutlined className="ml-2" />
      </Row>
    );
  }, [toggleEmail]);

  return !isAddAlternateEmail ? (
    <p
      className="my-0 text-sm w-500 logo-cursor card-header"
      onClick={toggleEmail}
    >
      + Alternate Email
    </p>
  ) : (
    <Form.Item
      label={label}
      name={["alternativeEmail"]}
      className="w-100 mb-0"
      rules={formattedRules}
    >
      <Input />
    </Form.Item>
  );
};
